import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import SEO from 'components/seo'
import Layout from 'components/layout'
import TestimonialsCarousel from 'components/testimonials-carousel'
import Hero from './hero'
import AggregateReviewSection from './aggregate-review-section'
import ReviewsListSection from './reviews-list-section'
import FooterCTASection from './footer-cta-section'

export const aggregateRating = 4.73

interface TestimonialEdge {
  node: Testimonial
}

type QueryResult = {
  testimonialsResult: {
    edges: readonly TestimonialEdge[]
  }
}

const query = graphql`
  query {
    testimonialsResult: allTestimonialsJson {
      edges {
        node {
          score
          quote
          name
          author_description
          date
          id
          from_physician
          is_featured
        }
      }
    }
  }
`

const ReviewsPage = () => {
  const { testimonialsResult } = useStaticQuery<QueryResult>(query)
  const testimonialsEdges = testimonialsResult.edges
  const filteredTestimonialsEdges = testimonialsEdges.filter(
    testimonialEdge => !testimonialEdge.node.from_physician
  )
  const [currentTestimonialsEdges, setCurrentTestimonialsEdges] = useState<any>(filteredTestimonialsEdges)

  return (
    <Layout>
      <SEO
        title="Reviews | Learn what customers think about Fellow"
      />
      <Hero />
      <AggregateReviewSection
        aggregateRating={aggregateRating}
        numReviews={currentTestimonialsEdges.length}
      />
      <TestimonialsCarousel dark showCustomers/>
      <ReviewsListSection
        currentTestimonialsEdges={currentTestimonialsEdges}
        setCurrentTestimonialsEdges={setCurrentTestimonialsEdges}
      />
      <FooterCTASection />
    </Layout>
  )
}

export default ReviewsPage
